import { axiosClient, referrer } from "../utils";

export const MessagesAPI = {
  generateModules: async (payload) => {
    payload.referrer = referrer();
    const res = await axiosClient.post(`/onboarding?type=generate-modules`, payload);
    return res.data;
  },
  fetchModules: async (payload) => {
    payload.referrer = referrer();
    const res = await axiosClient.get(`/onboarding?userId=${payload.userId}&type=get-modules`);
    return res.data;
  },
  updateModules: async (payload) => {
    payload.referrer = referrer();
    const res = await axiosClient.post(`/onboarding?type=update-modules`, payload);
    return res.data;
  },
  generateFeatures: async (payload) => {
    payload.referrer = referrer();
    const res = await axiosClient.post(`/onboarding?type=generate-features`, payload);
    return res.data;
  },
  fetchModuleChatHistory: async (payload) => {
    payload.referrer = referrer();
    const res = await axiosClient.get(`/onboarding?userId=${payload.userId}&module=${payload.module}&type=get-module-chat`);
    return res.data;
  },

  fetchSrs: async (payload) => {
    payload.referrer = referrer();
    const res = await axiosClient.get(`/onboarding?userId=${payload.userId}&type=get-srs`);
    return res.data;
  },
  generateSrs: async (payload, options) => {
    payload.referrer = referrer();
    const res = await axiosClient.post(`/onboarding?type=generate-srs`, payload, {
      signal: options.signal,
    });
    return res.data;
  },
  generate: async (payload, options) => {
    payload.referrer = referrer();
    const res = await axiosClient.post(`/onboarding?type=generate`, payload, {
      signal: options.signal,
    });
    return res.data;
  },
  getMessages: async (payload) => {
    payload.referrer = referrer();
    const res = await axiosClient.get(`/onboarding?userId=${payload.userId}&type=get-messages`);
    return res.data;
  },
  updateMessage: async (payload) => {
    payload.referrer = referrer();
    const res = await axiosClient.post(`/onboarding?type=update-message`, payload);
    return res.data;
  },
  buildApp: async (payload, options) => {
    payload.referrer = referrer();
    const res = await axiosClient.post(`/signup`, payload, {
      signal: options.signal,
    });
    return res.data;
  },
};
